module.exports = __webpack_public_path__ + "img/ico-down_arrow.70f80251.svg";